import { scrollToChatBottom } from './scrollToChatBottom';

/**
 * Scroll to chat bottom if auto-scroll is enabled and user is not interacting.
 * Initializes scroll tracking and event listeners on first call.
 */
export function scrollIfAllowed() {
    const chatContent = document.querySelector('.g-chatform-content');
    if (!chatContent) return;

    // Initialize flags and event listeners if not done yet
    if (typeof chatContent.isAutoScrollEnabled === 'undefined') {
        chatContent.isAutoScrollEnabled = true;
        chatContent.isUserInteracting = false;
        chatContent._lastScrollTop = chatContent.scrollTop;
        chatContent._lastMessageCount = chatContent.querySelectorAll('.g-chatform-message').length;

        let interactionTimeout;

        const setInteracting = () => {
            chatContent.isUserInteracting = true;
            clearTimeout(interactionTimeout);
            interactionTimeout = setTimeout(() => {
                chatContent.isUserInteracting = false;
            }, 100);
        };

        // Track user interaction events
        chatContent.addEventListener('wheel', setInteracting, { passive: true });
        chatContent.addEventListener('touchstart', setInteracting, { passive: true });
        chatContent.addEventListener('touchmove', setInteracting, { passive: true });
        chatContent.addEventListener('mousedown', setInteracting);

        // Track scroll direction to disable auto-scroll when user scrolls up
        chatContent.addEventListener('scroll', () => {
            const currentScrollTop = chatContent.scrollTop;

            if (chatContent.isUserInteracting && currentScrollTop < chatContent._lastScrollTop - 5) {
                chatContent.isAutoScrollEnabled = false;
            }

            chatContent._lastScrollTop = currentScrollTop;
        }, { passive: true });

        // Watch for new messages to re-enable auto-scroll
        const observer = new MutationObserver(() => {
            const currentMessageCount = chatContent.querySelectorAll('.g-chatform-message').length;

            if (currentMessageCount > chatContent._lastMessageCount) {
                chatContent.isAutoScrollEnabled = true;
                chatContent._lastMessageCount = currentMessageCount;
            }
        });

        observer.observe(chatContent, { childList: true, subtree: true });
    }

    const autoEnabled = chatContent.isAutoScrollEnabled !== false;
    const interacting = chatContent.isUserInteracting === true;

    // Only scroll if auto-scroll is enabled and user is not interacting
    if (autoEnabled && !interacting) {
        scrollToChatBottom(0);
    }
}

